function fixBannerBar() {
    var jQuerylogo = jQuery("#logo");
    var jQuerynav = jQuery("#topMiddleContainer");
    var jQuerymiddleNav = jQuery('.middleNav');

    if (jQuery(window).scrollTop() > jQuerylogo.data("top")) {
        // Scroll past
        jQuerylogo.removeClass('logoInView').addClass('logoOutView');
        jQuerylogo.removeClass('logoInView').addClass('logoOutView');
        
        jQuerynav.removeClass('navInView').addClass('navOutView');
        jQuerynav.removeClass('navInView').addClass('navOutView');
        
        jQuerynav.removeClass('navInView').addClass('navOutView');
        jQuerynav.removeClass('navInView').addClass('navOutView');
    } else {
        // Scroll back
        jQuerylogo.removeClass('logoOutView').addClass('logoInView');
        jQuerylogo.removeClass('logoOutView').addClass('logoInView');
        
        jQuerynav.removeClass('navOutView').addClass('navInView');
        jQuerynav.removeClass('navOutView').addClass('navInView');
    }
}

// Shopping Cart

jQuery(window).on("load", function() {
    if ( sessionStorage.getItem('_quickscript') ) {
        var _quickscript = JSON.parse(sessionStorage.getItem('_quickscript'));
        jQuery('.cart-icon span').text(_quickscript["step-1-part-1"].qsMedications.length);
        jQuery('.cart-menu span').text(_quickscript["step-1-part-1"].qsMedications.length);
        jQuery('.cart-icon').show();
        jQuery('.cartNav').show();
    }
});

// jQuery("#logo").data("top", jQuery("#logo").offset().top);

// jQuery("#topMiddleContainer").data("top", jQuery("#topMiddleContainer").offset().top);

jQuery(window).scroll(fixBannerBar);

fixBannerBar();